// Notification abstraction — the only file that imports from sonner.
// Feature code calls notify.success(...) — never imports toast directly.
// To swap the notification library, update only this file.

import { toast } from 'sonner';

export interface NotifyOptions {
  description?: string;
  duration?: number;
  id?: string | number;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const notify = {
  success: (message: string, options?: NotifyOptions) => toast.success(message, options),

  error: (message: string, options?: NotifyOptions) => toast.error(message, options),

  warning: (message: string, options?: NotifyOptions) => toast.warning(message, options),

  info: (message: string, options?: NotifyOptions) => toast.info(message, options),

  loading: (message: string, options?: NotifyOptions) => toast.loading(message, options),

  dismiss: (id?: string | number) => toast.dismiss(id),

  promise: <T>(
    promise: Promise<T>,
    messages: { loading: string; success: string; error: string },
  ) => toast.promise(promise, messages),
};
